import Cookies from "js-cookie";

const tokenKey = "token";


export function getToken() {
  return Cookies.get(tokenKey);
}

export function setToken(token) {
  return Cookies.set(tokenKey, token);
}

export function removeToken() {
  return Cookies.remove(tokenKey);
}

/** */
/* export function getSysName() {
  return Cookies.get(sysNameKey);
}
export function setSysName(name) {
  return Cookies.set(sysNameKey, name);
}
export function removeSysName() {
  return Cookies.remove(sysNameKey);
} */